<template>
  <svg
    version="1.1"
    id="레이어_5"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 75.6 74.5"
    style="enable-background:new 0 0 75.6 74.5;"
    xml:space="preserve"
  >
    <g>
      <path
        class="st0"
        d="M75.6,36.8l-2.1-12c-0.2-0.9-1-1.6-1.9-1.6L66.3,23c-0.6-1.1-1.2-2.2-1.9-3.3l2.5-4.6c0.5-0.8,0.3-1.9-0.5-2.5
		l-9.3-7.8c-0.7-0.6-1.8-0.6-2.5,0L50.5,8c-1.2-0.5-2.4-0.9-3.6-1.3l-1-5.1c-0.2-0.9-1-1.6-2-1.6H31.7c-1,0-1.8,0.7-2,1.6l-1,5.1
		c-1.2,0.4-2.4,0.8-3.6,1.3L21,4.8c-0.7-0.6-1.8-0.6-2.5,0l-9.3,7.8c-0.7,0.6-0.9,1.6-0.5,2.5l2.5,4.6c-0.7,1.1-1.3,2.2-1.9,3.3
		L4,23.2c-0.9,0-1.7,0.7-1.9,1.6L0,36.8c-0.2,0.9,0.3,1.9,1.2,2.2L6.1,41c0.2,1.3,0.4,2.5,0.7,3.7l-3.9,3.5
		c-0.7,0.6-0.9,1.7-0.4,2.5l6.1,10.5c0.5,0.8,1.5,1.2,2.4,0.9l5-1.7c0.9,0.9,1.9,1.7,2.9,2.4L18,68.1c-0.2,0.9,0.4,1.9,1.3,2.2
		l11.5,4.1c0.9,0.3,1.9,0,2.4-0.8l2.8-4.5c0.6,0,1.3,0.1,1.9,0.1c0.6,0,1.3,0,1.9-0.1l2.8,4.5c0.5,0.8,1.5,1.2,2.4,0.8l11.4-4.1
		c0.9-0.3,1.4-1.2,1.3-2.2l-0.8-5.2c1-0.8,2-1.6,2.9-2.4l5,1.7c0.9,0.3,1.9-0.1,2.4-0.9l6.1-10.5c0.5-0.8,0.3-1.9-0.4-2.5l-4-3.5
		c0.3-1.2,0.5-2.5,0.7-3.7l4.9-1.9C75.2,38.7,75.7,37.7,75.6,36.8z M66.9,37.7l-0.1,0.1l-0.2,0.1l-0.1,0.1l-0.2,0.1l-0.1,0.1
		c0,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2
		c0,0,0,0.1,0,0.1c-0.1,1.8-0.5,3.7-1,5.4c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2
		c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2l0.1,0.2l0.1,0.2c0,0.1,0.1,0.1,0.1,0.2l0.1,0.2l0.1,0.2c0,0,0.1,0.1,0.1,0.1l3.6,3.2
		l-4.5,7.7l-4.6-1.5c0,0-0.1,0-0.1,0h-0.2h-0.2h-0.2h-0.2h-0.2l-0.2,0l-0.2,0.1l-0.2,0.1L58,56.6l-0.2,0.1c0,0-0.1,0.1-0.1,0.1
		c-1.3,1.3-2.7,2.4-4.2,3.5l-0.1,0.1l-0.1,0.1l-0.1,0.2c0,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2
		c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1l0.7,4.8l-8.4,3
		l-2.6-4v-0.1c0-0.1-0.1-0.2-0.2-0.2l-0.1-0.1L42,65.4l-0.2-0.1l-0.2-0.1l-0.2-0.1l-0.2-0.1h-0.2h-0.2h-0.4c-1.8,0.2-3.7,0.2-5.5,0
		h-0.4h-0.1l-0.3,0.1h-0.1l-0.2,0.1l-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1l-0.1,0.2L33.1,66
		l-2.5,4.1l-8.4-3l0.7-4.8c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2
		c0-0.1,0-0.2-0.1-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1
		l-0.1-0.1c-1.5-1-2.9-2.2-4.2-3.5l-0.1-0.1l-0.2-0.1l-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.2-0.1h-0.2c-0.1,0-0.1,0-0.2,0h-0.2h-0.4
		h-0.2h-0.1l-4.6,1.5l-4.4-7.7l3.6-3.2l0.1-0.1l0.2-0.2l0.1-0.2l0-0.2l0.1-0.2l0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2
		c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c-0.5-1.8-0.9-3.6-1-5.4c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2l-0.1-0.2
		c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.2L9.3,38l-0.1-0.1L9,37.8c-0.1,0-0.1-0.1-0.2-0.1
		l-0.1-0.1l-4.5-1.8l1.5-8.8l4.8-0.1c0.2,0,0.3,0,0.5-0.1h0.1c0.1,0,0.3-0.1,0.4-0.2c0,0,0.1,0,0.1-0.1c0.1-0.1,0.3-0.2,0.4-0.3
		l0.1-0.1c0.1-0.1,0.2-0.2,0.2-0.4v-0.1c0.8-1.7,1.7-3.3,2.8-4.8c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.2
		l0.1-0.2v-0.2V20v-0.2c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2s0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1,0-0.1L13,14.7l6.8-5.8l3.8,3
		l0.1,0.1l0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0,0.3,0.1,0.5,0.1h0.2h0.2h0.2c0.1,0,0.2,0,0.3-0.1h0.1c1.7-0.8,3.5-1.5,5.3-2H31
		l0.2-0.1l0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.2-0.1,0.2-0.2C32,9.6,32,9.5,32.1,9.4c0,0,0-0.1,0-0.1
		c0-0.1,0.1-0.2,0.1-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2l1-4.7h8.9l1,4.7c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0.1,0.2
		c0,0.1,0,0.1,0.1,0.2l0.1,0.2l0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.1,0.1l0.2,0.1l0.1,0.1l0.2,0.1c0.1,0,0.1,0,0.2,0.1
		l0.2,0.1c1.8,0.5,3.6,1.1,5.2,1.9h0.1c0.1,0,0.2,0.1,0.3,0.1h0.2h0.2h0.2c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2l0.1-0.1
		l0.1-0.1l3.8-3l6.8,5.7l-2.3,4.2c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2v0.2v0.2
		v0.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2l0.1,0.1c1.1,1.5,2,3.1,2.8,4.8v0.1c0.1,0.1,0.1,0.3,0.2,0.4
		l0.1,0.1c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.2h0.1c0.2,0,0.3,0.1,0.5,0.1l4.8,0.1l1.5,8.8L66.9,37.7
		z"
      />
      <path
        class="st0"
        d="M37.8,17.5C26.9,17.5,18,26.3,18,37.3S26.9,57,37.8,57s19.8-8.9,19.8-19.8C57.6,26.3,48.7,17.5,37.8,17.5z
		 M37.8,53C29.1,53,22,46,22,37.3s7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8C53.6,46,46.5,53,37.8,53z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ConfigIcon',
};
</script>

<style scoped>
.st0 {
  fill: #121212;
}
</style>
